import { AspInvoiceCreditNotesRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspInvoiceCreditNotes() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  // Called per contact — callers keep the returned CreditNotes.
  async function fetchAspInvoiceCreditNotes(params: AspInvoiceCreditNotesRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspInvoiceCreditNotes(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchAspInvoiceCreditNotes };
}
